// Centralny config — jeden plik do zmiany przy przełączaniu dev/prod
// W przeglądarce: backend na tym samym hoście co frontend, port 8080
// Przy dev (localhost:3000) też działa - wskaże na localhost:8080
function resolveApiUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:8081';
    if (window.location.protocol === 'https:') return '/api';
    return 'http://' + host + ':8080';
  }
  return 'http://localhost:8081';
}
export const API_URL = resolveApiUrl();



// WEBPACK FOOTER //
// ./src/utils/config.js